import api from '../callApi';

const completeVideo = (apiRequestData, actionCompletedTime) => {
    const request = {
        ...apiRequestData,
        actionCompletedTime
    };

    return api.post('Widget/CompleteVideoAsync', request).then(response => response);
};

export default completeVideo;



// WEBPACK FOOTER //
// ./src/utils/video/videoApi.js